import { IItemPicker } from "../../../../../component/Global/Picker";
import { IResponseCardInit } from "../../../../../services/cards/types/response";

export const initData = { type: "", data: [] };
export const initDataModal: IItemPicker = { text: "", id: "" };
